import * as React from "react";
import { Gapped, MenuSeparator, RadioGroup } from "react-ui";

import { SORT_RADIO_CLICK } from "../../../metricsAction";
import { MetricsActionPayload, trackAction } from "../../../Internals/Metrics/MetricsProvider";
import { nullElement, pullContext } from "../../../TypingUtils";
import { DataType, SortDataType, SortType } from "../../MultiLine/MultiLineTypes";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { tablePathContextTypes } from "../../CrossfitTable/TablePathContext";

import { Header } from "./SortRadioGroup.styles";

export interface SortRadioGroupProps {
    dataType: SortDataType;
    dataSave: boolean;
    dataPath: AbsoluteModelPath;
    header?: string | JSX.Element;
    multilinePath: AbsoluteModelPath;
    items: [SortType, string];
    value?: SortType;
    sort: (stickyTablePath: string, value: SortType) => void;
    children?: React.ReactNode;
}

interface SortRadioGroupState {
    value?: SortType;
}

interface SortRadioGroupContext {
    stickyTablePath: string;
}

function sortRadioGroupSelector(
    { dataPath }: SortRadioGroupProps,
    _: SortRadioGroupState,
    value: SortType
): MetricsActionPayload {
    return {
        path: dataPath.toLegacyPath(),
        value: value,
    };
}

export class SortRadioGroup extends React.Component<SortRadioGroupProps, SortRadioGroupState> {
    public static defaultProps: Partial<SortRadioGroupProps> = {
        dataType: DataType.Number,
    };
    public static contextTypes = tablePathContextTypes;

    public constructor(props: SortRadioGroupProps) {
        super(props);
        this.state = { value: this.props.value };
    }

    public render(): React.ReactNode {
        const header: React.ReactNode = this.props.header ? (
            <div>
                <Header>{this.props.header}</Header>
                <MenuSeparator />
            </div>
        ) : (
            nullElement
        );

        return (
            <div>
                {header}
                <RadioGroup<SortType> value={this.state.value} onValueChange={this.handleOnChange}>
                    <Gapped vertical gap={10}>
                        {this.props.children}
                    </Gapped>
                </RadioGroup>
            </div>
        );
    }

    private readonly handleOnChange = (value: SortType): void => {
        this.setState({ value: value });
        setTimeout(() => this.runSort(value), 500);
    };

    @trackAction(SORT_RADIO_CLICK, sortRadioGroupSelector)
    private runSort(value: SortType): void {
        this.props.sort(this.getContext().stickyTablePath, value);
    }

    private getContext(): SortRadioGroupContext {
        return pullContext<SortRadioGroupContext>(this);
    }
}
